import React, { useEffect, useState } from "react";
import { notification } from "antd";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation, useNavigate } from "react-router-dom"

import { fetchIpAddress } from "../../../controllers/API";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { faArrowLeft, faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import { list as getGeneralData, updateGeneralData} from "../../../controllers/V1/generalDataController"

const AddEditData = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);

  const [isLoading, setIsLoading] = useState(false);

  /*********************** End ************************ */
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    const { name, value } = e.target;
    if(name ==='analyser_emails'){
      const regex = /^[a-zA-Z0-9_@,.]*$/;
      const cleanValue = value.replace(/\s+/g, "");
      if (regex.test(cleanValue)) {
        setAddEditSata((pre) => ({
          ...pre,
          [name]: cleanValue,
        }));
      }
    } else{
      setAddEditSata((pre) => ({
        ...pre,
        [e.target.name]: e.target.value,
      }));
    }
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

 

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);
        const options ={
          edit_id                 : form.get('edit_id'), 
          analyser_start_time     : form.get('analyser_start_time'), 
          analyser_end_time       : form.get('analyser_end_time'), 
          analyser_emails         : form.get('analyser_emails'), 
          invoice_start_time      : form.get('invoice_start_time'), 
          invoice_end_time        : form.get('invoice_end_time'),
          // enable_draw_time_restriction : form.get('enable_draw_time_restriction'),

        }
        const res = await updateGeneralData(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated.",
            description: `Data updated Successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
          });
        }
      
    } catch (error) {
      console.log("error", error);
    }
  };

  

  const fetchGeneralInfo = async () => {
    try {
      setIsLoading(true);
      const option = { 
        select :  {
          analyser_start_time     : true, 
          analyser_end_time       : true,
          invoice_start_time      : true, 
          invoice_end_time        : true,
          enable_draw_time_restriction : true,
        }
      }
      const res = await getGeneralData(option);
      if (res.status === true && res.result !== 'undefined') {
        setIsLoading(false);
        setAddEditSata(res.result);
      } else {

      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchGeneralInfo();
    document.title = `U-Winn CRM || General Data`;
  }, []);


  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> General Data </h5>
          </React.Fragment>
          <Link to={"/dashboard"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <FontAwesomeIcon icon={faArrowLeft}/> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
                <input type="hidden" name="edit_id" id="edit_id" value={ADDEDITDATA?._id}/>
                <div className="row ">
                  <div className="row">
                    <div className="form-group col-lg-2 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="analyser_start_time" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Analyser Start Time :{" "}
                      </label>
                      <input
                        title="Analyser Start Time."
                        placeholder="Enter analyser start time."
                        type="text"
                        name="analyser_start_time"
                        className="form-control store_input_field"
                        id="analyser_start_time"
                        value={ADDEDITDATA?.analyser_start_time}
                        onChange={handleChange}
                      />
                      {error.analyser_start_time && ( <p style={{ color: "red" }}>{error.analyser_start_time}</p> )}
                    </div>

                    <div className="form-group col-lg-2 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="analyser_end_time" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Analyser End Time :{" "}
                      </label>
                      <input
                        title="Analyser End Time."
                        placeholder="Enter analyser end time."
                        type="text"
                        name="analyser_end_time"
                        className="form-control store_input_field"
                        id="analyser_end_time"
                        value={ADDEDITDATA?.analyser_end_time}
                        onChange={handleChange}
                      />
                      {error.analyser_end_time && ( <p style={{ color: "red" }}>{error.analyser_end_time}</p> )}
                    </div>

                    <div className="form-group col-lg-8 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="analyser_emails" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Analyser CC-Emails :{" "}
                      </label>
                      <input
                        title="Analyser CC-Emails."
                        placeholder="Enter analyser CC-Emails."
                        type="text"
                        name="analyser_emails"
                        className="form-control store_input_field"
                        id="analyser_emails"
                        value={ADDEDITDATA?.analyser_emails}
                        onChange={handleChange}
                      />
                      {error.analyser_emails && ( <p style={{ color: "red" }}>{error.analyser_emails}</p> )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="invoice_start_time" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Invoice Start Time :{" "}
                      </label>
                      <input
                        title="Invoice Start Time."
                        placeholder="Enter invoice start time."
                        type="text"
                        name="invoice_start_time"
                        className="form-control store_input_field"
                        id="invoice_start_time"
                        value={ADDEDITDATA?.invoice_start_time}
                        onChange={handleChange}
                      />
                      {error.invoice_start_time && ( <p style={{ color: "red" }}>{error.invoice_start_time}</p> )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="invoice_end_time" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Invoice End Time :{" "}
                      </label>
                      <input
                        title="Invoice End Time."
                        placeholder="Enter invoice end time."
                        type="text"
                        name="invoice_end_time"
                        className="form-control store_input_field"
                        id="invoice_end_time"
                        value={ADDEDITDATA?.invoice_end_time}
                        onChange={handleChange}
                      />
                      {error.invoice_end_time && ( <p style={{ color: "red" }}>{error.invoice_end_time}</p> )}
                    </div>

                    {/* <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="enable_draw_time_restriction" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Draw Time Restriction :{" "}
                      </label>
                      <select
                        name="enable_draw_time_restriction"
                        id="enable_draw_time_restriction"
                        className="form-control store_input_field"
                        value={ADDEDITDATA?.enable_draw_time_restriction || 'N'}
                        onChange={handleChange}
                      >
                        <option value="Y">Enable</option>
                        <option value="N">Disable</option>
                      </select>
                      {error.enable_draw_time_restriction && ( <p style={{ color: "red" }}>{error.enable_draw_time_restriction}</p> )}
                    </div> */}

                  </div>
                  
                </div>  
                <div className="inventory_edit_submit_btn">
                  <button type="submit" className="btn btn-primary inventory_save_button" > Save </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default AddEditData;
